import React from 'react';

import Content from '../../../Content';

import {IContentfulEmbeddedEntryInlineProps} from './IContentfulEmbeddedEntryInline';

const ContentfulEmbeddedEntryInline = ({data}: IContentfulEmbeddedEntryInlineProps): React.ReactElement => {
	return <Content data={data.target} />;
};

export default ContentfulEmbeddedEntryInline;
